export const FETCH_DETAILS = 'FETCH_DETAILS';
export const STORE_DETAILS = 'STORE_DETAILS';
export const STORE_DETAILS_RESET = 'STORE_DETAILS_RESET';

export const FETCH_USER_CARD_INFO = 'FETCH_USER_CARD_INFO';
export const STORE_USER_CARD_INFO = 'STORE_USER_CARD_INFO';
export const STORE_USER_CARD_INFO_RESET = 'STORE_USER_CARD_INFO_RESET';